module.exports = __webpack_public_path__ + "static/img/RWD966_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWD966_1.png
// module id = 4qNf
// module chunks = 0